module.exports = __webpack_public_path__ + "img/397.e4921b15.jpg";